module.exports = __webpack_public_path__ + "img/change_driver.1b9613b1.png";